import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@portals-platform/ui';
import type { MouseEvent } from 'react';
import { type CertificateRow, useDeleteCertificate } from '../../data-access/index.js';
import { ServerErrorAlert } from '../server-error-alert.js';

export interface DeleteCertificateDialogProps {
  certificate: CertificateRow | null;
  onClose: () => void;
}

export function DeleteCertificateDialog({ certificate, onClose }: DeleteCertificateDialogProps) {
  const { mutate, reset, isPending, error } = useDeleteCertificate();

  const close = () => {
    reset();
    onClose();
  };

  const handleConfirm = (event: MouseEvent) => {
    event.preventDefault();
    if (certificate) {
      mutate(certificate.id, { onSuccess: close });
    }
  };

  return (
    <AlertDialog
      open={certificate !== null}
      onOpenChange={(open) => {
        if (!open && !isPending) {
          close();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete certificate</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete certificate {certificate?.policyNumber}?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ServerErrorAlert title="Could not delete certificate" error={error ?? undefined} />
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction variant="destructive" disabled={isPending} onClick={handleConfirm}>
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
